export default __webpack_public_path__ + "static/media/Github.9c1f6c77.svg";